import React from 'react';

/*
 *  @Author:        Sergio Balaguer Carmona
 *  @Description:   Stateless component that renders a Setting icon (3 vertical dots)
 */

const Settings = ( props ) => {

    return (<g id="Group_1608" data-name="Group 1608" transform="translate(-742.149 -3450.373)">
            <path id="path"
                  d="M14.9,24.8A10.9,10.9,0,1,0,4,13.9,10.932,10.932,0,0,0,14.9,24.8Zm0,17.3A10.9,10.9,0,1,0,25.8,53,10.932,10.932,0,0,0,14.9,42.1Zm0,39.1A10.9,10.9,0,1,0,25.8,92.1,10.932,10.932,0,0,0,14.9,81.2Z"
                  transform="translate(739.899 3449.123)"/>
        </g>
    )
};

export default Settings;

